export const processLinkUrl = (link: any) => {
  if (link?.__typename === 'Article'){
    return `/article/${link?.slug}`
  } else if(link?.__typename === 'Document'){
    return `/docs/${link?.slug}`
  } else if (link?.__typename === 'CustomerStory'){
    return `/customer-story/${link?.slug}`
  } else if(link?.slug){
    return `/${link?.slug}`
  } else if (link?.url && (link?.url !== '')){
    return link?.url;
  } else {
    return link
  }
}